import RolesIndex from '@/views/roles/RolesIndex.vue'
import RoleCreate from '@/views/roles/RoleCreate.vue'
import RoleEdit from '@/views/roles/RoleEdit.vue'


export default [
  {
    path: '/roles',
    name: 'roles.index',
    component: RolesIndex,
    meta: {
      title: 'Roles Management',
      requiresAuth: true
    }
  },
  {
    path: '/roles/create',
    name: 'roles.create',
    component: RoleCreate,
    meta: {
      title: 'Create Role',
      requiresAuth: true
    }
  },
  {
    path: '/roles/:id/edit',
    name: 'roles.edit',
    component: RoleEdit,
    meta: {
      title: 'Edit Role',
      requiresAuth: true
    }
  }
]
